import { ModuleWithProviders, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { NgbDropdownModule, NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxMaskModule } from 'ngx-mask';

import { DataTableModule } from 'angular-4-data-table-bootstrap-4';

import { SharedModule } from '../../shared.module';
import { UscDashboardComponent } from './usc-dashboard/usc-dashboard.component';
import { UscBiHeaderComponent } from './usc-bi-header/usc-bi-header.component';
import { UscBiComponent } from './usc-bi.component';
import { MenuModule, SidebarModule } from '@syncfusion/ej2-angular-navigations';
import { EmailComposerComponent } from '../common/email-composer/email-composer.component';
import { UscBiService } from '../../services/usc-bi/usc-bi.service';

const UscBiRouting: ModuleWithProviders = RouterModule.forChild([
  {
    path: 'usc-bi/dashboard',
    component: UscDashboardComponent,
  }, 
]);

@NgModule({
  exports: [
  ],
  imports: [
    NgbDropdownModule.forRoot(),
    UscBiRouting, 
    SharedModule,
    DataTableModule,
    NgxMaskModule.forRoot(),
    SidebarModule,
    MenuModule,
  ],
  declarations: [
    UscBiComponent,
    UscDashboardComponent,
    UscBiHeaderComponent,
    EmailComposerComponent,
  ],
  providers: [
    UscBiService,
    NgbModal,
    NgbActiveModal,
  ],
  // add components here for dynamic loading
  entryComponents: [ 
    EmailComposerComponent,
  ]
})

export class UscBiModule {}



// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-bi/usc-bi.module.ts